<template>
    <div class="bannerWrapper">
        <img 
            class="illustration"
            :src="require('@/assets/illustrations/drawings/skyscape.svg')" 
            alt=""
        >
        <div class="banner">
            <img 
                class="logoImg"
                :src="require('@/assets/logo/logoSVG.svg')" 
                alt=""
            >
            <div class="text">
                <h2 class="title" v-html="$t(`home.bannerText`)"></h2>
                <button @click="$emit('openContactPopup')">{{ $t(`buttons.contact`) }}</button>
                <button @click="$emit('scrollToProducts')">{{ $t(`buttons.viewProducts`) }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'homeBanner',
    data() {
        return {

        }
    },  
    methods: {
        
    },
}
</script>
<style scoped>
.bannerWrapper {
    position: relative;
    margin-bottom: 50px;
    height: 520px;
    background: rgb(226, 228, 233);
    overflow: hidden;
}
.banner {
    position: relative;
    width: 1350px;
    height: 400px;
    margin: 0 auto;
    text-align: start;
}
.illustration {
    position: absolute;
    width: 100%;
    right: 0;
    bottom: -60px;
    opacity: 1;
}
.logoImg {
    position: absolute;
    top: 85px;
    left: 0px;
    z-index: 10;
    width: 455px;
    height: auto;
}
.text {
    position: absolute;
    right: 50px;
    bottom: 0;
    top: 0;
    margin: auto;
    font-size: 28px;
    width: 550px;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
}
.text h2 {
    color: rgb(66, 74, 95);
}
.title >>> span {
    color: orange;
}
button {
    width: 240px;
    height: 55px;
    border: 2px solid transparent;
    border-radius: 5px;
    margin-right: 25px;
    margin-left: 0px;
    margin-top: 30px;
    font-weight: bold;
    font-size: 20px;
    background: rgb(66, 74, 95);
    color: white;
    -webkit-transition: .2s;
    -o-transition: .2s;
    transition: .2s;
}
button:last-child {
    background: rgb(226, 228, 233);
    border: 2px solid rgb(66, 74, 95);
    color: rgb(66, 74, 95);
    margin-right: 0;
}
button:hover {
    background: rgb(226, 228, 233);
    border: 2px solid rgb(66, 74, 95);
    color: rgb(66, 74, 95);
    cursor: pointer;
}
button:last-child:hover {
    color: white;
    background: rgb(66, 74, 95);
}
@media (max-width: 1350px) {
    .banner {
        width: 100%;
    }
    .logoImg {
        left: 25px;
    }
    .text {
        right: 25px;
        bottom: 0;
        top: 0;
        margin: auto;
        font-size: 28px;
        width: 550px;
    }
    .illustration {
        position: absolute;
        bottom: -2px;
        opacity: 1;
    }
}
@media (max-width: 1150px) {
    .text {
        right: -10px;
        top: 17px;
        font-size: 24px;
    }
    button {
        width: 240px;
    }
}
@media (max-width: 1125px) {
    .bannerWrapper {
        height: 650px;
        margin-bottom: 50px;
    }
    .logoImg {
        left: 0;
        right: 0;
        top: 10px;
        margin: auto;
    }
    .text {
        left: 0;
        right: 0;
        bottom: 0;
        top: 285px;
        margin: auto;
        font-size: 20px;
        text-align: center;
    }
}
@media (max-width: 550px) {
    .bannerWrapper {
        height: -webkit-fit-content;
        height: -moz-fit-content;
        height: fit-content;
        margin-bottom: -25px;
    }
    .banner {
        height: -webkit-fit-content;
        height: -moz-fit-content;
        height: fit-content;
        padding-bottom: 100px;
        text-align: center;
    }
    .logoImg {
        position: relative;
        width: 85%;
        margin-bottom: 10px;
    }
    .text {
        position: relative;
        top: 25px;
        width: 90%;
        font-size: 18px;
    }
    button {
        width: 45%;
    }
    .illustration {
        width: 121%;
    }
}
@media (max-width: 400px) {
    button {
        width: 47%;
        margin-right: 10px;
        font-size: 18px;
    }
}
</style>